import { createFileRoute } from "@tanstack/react-router"
import { RulesSettingsPage } from "~/components/rules/RulesSettingsPage"
import NotFound from "~/components/reusable/NotFound"
import useShowHelix from "~/hooks/useShowHelix"

export const Route = createFileRoute("/_auth/settings/_layout/rules")({
  component: RulesRoute,
})

// Rules flag variants in the Demand 2.0 tables only, so they share its flag.
function RulesRoute() {
  const showHelix = useShowHelix()
  if (!showHelix) return <NotFound />
  return <RulesSettingsPage />
}
